import styled from 'styled-components';

const FavoritesGridStyles = styled.div`
  position: relative;
  height: 100%;
  .grid-container {
    position: relative;
    max-width: 1108px;
    padding: 0px 25px;
    margin: 0 auto;
    height: 100%;
  }
  .favoritegrid-wrap {
    position: relative;
    .btn-wrap {
      margin-top: 30px;
      display: flex;
      justify-content: center;
    }
  }
  .favoritegrid {
    gap: 0px;
    margin: auto -10px;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;
    display: flex;
    width: auto;
    .retail-hometile {
      position: relative;
      flex: 0 1 33.3333%;
      padding: 0px;
      min-width: 0px;
      @media only screen and (max-width: 900px) {
        flex: 0 1 50%;
      }
      @media only screen and (max-width: 600px) {
        flex: 0 1 100%;
      }
    }
  }

  .DXItemsGrid-heading {
    font-weight: 600;
    font-size: 25px;
    line-height: 30px;
    letter-spacing: -0.35px;
    color: #25292d;
    font-family: 'source-sans-pro';
  }
  .DXItemsGrid-subheading {
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: #4e5255;
    margin-bottom: 12px;
  }
`;

export default FavoritesGridStyles;
